var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.16663C3 0.614341 2.55228 0.166626 2 0.166626C1.44772 0.166626 1 0.614341 1 1.16663V10.1666C1 10.7189 1.44772 11.1666 2 11.1666C2.55228 11.1666 3 10.7189 3 10.1666V1.16663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.3334C2.82843 16.3334 3.5 15.6618 3.5 14.8334C3.5 14.0049 2.82843 13.3334 2 13.3334C1.17157 13.3334 0.5 14.0049 0.5 14.8334C0.5 15.6618 1.17157 16.3334 2 16.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkIcon);
export default __webpack_public_path__ + "static/media/exclamation-mark-icon.0eb88a3ae2258e17d4d5a66fafc1aaee.svg";
export { ForwardRef as ReactComponent };